import { makeStyles } from '@material-ui/core';
import { THEME } from 'GlobalStyles';
import { GRADIENT } from 'UI/constants/styles';

export const styles = {
  emptyDiv: {
    display: 'none'
  },
  buttonResponsive: {
    display: 'flex',
    justifyContent: 'center'
  }
};

const GRADIENT_TEXT_COLOR = '#8872F0';

const { primary, secondary } = THEME.palette;

const sizeSmallStyles = {
  fontSize: '0.8125rem !important',
  whiteSpace: 'nowrap'
};

const labelSpacing = THEME.spacing(0, 0.5);

const getShineStyles = customBackground => ({
  '&:not(:disabled)': {
    position: 'relative',
    overflow: 'hidden',
    animation: 'box-shadow 0.3s ease-in-out',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-75%',
      width: '50%',
      height: '100%',
      background: customBackground,
      transform: 'skewX(-30deg)',
      transition: 'left 1s ease-in-out',
      pointerEvents: 'none',
      zIndex: 1
    },
    '&:hover::after': {
      left: '130%'
    },
    '& > *': {
      position: 'relative',
      zIndex: 2
    }
  }
});

export const useCustomFPActionButton = makeStyles(
  theme => ({
    containedPrimary: {
      color: theme.palette.common.white,
      backgroundImage: GRADIENT,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark
      },
      '&:focus': {
        backgroundColor: theme.palette.primary.FP400
      },
      ...getShineStyles(
        'linear-gradient(120deg, rgb(255 255 255 / 20%) 0%, rgb(255 255 255 / 20%) 45%, rgba(255, 255, 255, 0.2) 50%, rgb(255 255 255 / 20%) 55%, rgb(255 255 255 / 10%) 100%)'
      )
    },
    outlinedPrimary: {
      backgroundColor: 'unset',
      color: GRADIENT_TEXT_COLOR,
      borderColor: '#8872F0 #b09eec #8872F0 #4056F4',
      borderWidth: '1px',
      borderStyle: 'solid',
      '&:hover': {
        backgroundColor: secondary.main
      },
      ...getShineStyles('linear-gradient(120deg, #8772f034, #b09eec20, #5c49bd25)')
    },
    label: {
      padding: labelSpacing
    }
  }),
  { name: 'CustomFPButtonStyles' }
);

export const useStyles = makeStyles(
  theme => ({
    root: {
      border: 0,
      ...theme.button,
      boxShadow: 'unset',
      '&:hover': {
        boxShadow: '0px 2px 2px -4px rgba(3, 13, 40, 0.08)'
      }
    },
    contained: {},
    outlined: {},
    containedPrimary: {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark
      },
      '&:focus': {
        backgroundColor: theme.palette.primary.FP400
      }
    },
    containedSecondary: {
      color: secondary.FP700,
      backgroundColor: secondary.main,
      '&:hover': {
        backgroundColor: secondary.dark
      },
      '&:focus': {
        backgroundColor: secondary.FP400
      }
    },
    outlinedPrimary: {
      backgroundColor: 'unset',
      color: primary.light,
      borderColor: theme.palette.primary.light,
      borderWidth: '1px',
      borderStyle: 'solid',
      '&:hover': {
        backgroundColor: secondary.main
      }
    },
    outlinedSecondary: {
      backgroundColor: 'unset',
      border: `1px solid ${secondary.FP700}`,
      '&:hover': {
        backgroundColor: secondary.main
      },
      '&:focus': {
        backgroundColor: secondary.FP300
      }
    },
    textSecondary: {
      color: secondary.FP700
    },
    text: {
      width: 'unset !important',
      minWidth: 'unset !important'
    },
    sizeSmall: sizeSmallStyles
  }),
  { name: 'MuiButton' }
);
